import { ToastContainer } from 'react-toastify';

export const ToastProvider = () => (
  <ToastContainer
    newestOnTop
    theme="light"
    hideProgressBar
    autoClose={5000}
    closeButton={false}
    position="top-right"
  />
);
